import "./index.0.css";
import { INJECT_UICORE_BUS } from "../../../../lib/utils/consts";
const __script_base__ = {
  name: 'WImage',
  model: {
    prop: 'src'
  },
  props: {
    src: {
      type: String,
      required: true
    },
    fallbackSrc: {
      type: String,
      default: ''
    },
    fillMode: {
      type: String,
      default: 'fill'
    },
    useFallbackIfSrcIsEmpty: {
      type: Boolean,
      default: true
    },
    css: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentSrc: ''
    };
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    }
  },
  watch: {
    src: {
      handler(v) {
        if (!v && !this.useFallbackIfSrcIsEmpty) {
          // 网址为空时，不使用兜底图的话，要展示一个白块
          // eslint-disable-next-line no-param-reassign
          v = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
        }
        this.currentSrc = v;
      },
      immediate: true
    }
  },
  methods: {
    handleImageError() {
      var _this$uc;
      const fallbackSrc = this.fallbackSrc || ((_this$uc = this.uc) === null || _this$uc === void 0 ? void 0 : _this$uc.config.brokenImageReplacement);
      if (fallbackSrc && this.currentSrc !== fallbackSrc) this.currentSrc = fallbackSrc;
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('img', _vm._g({
    staticClass: "w-image",
    style: "object-fit:" + _vm.fillMode + "; " + _vm.css,
    attrs: {
      "src": _vm.currentSrc
    },
    on: {
      "error": _vm.handleImageError
    }
  }, _vm.$listeners));
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Image/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);